function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("title", null, "VF_"), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M148 129.7c9.1 0 14.4 5.1 15.6 11.7h15c-1.8-15.4-13-24.7-30.2-24.7-15.8 0-29.1 7.9-33.1 24.4h-7.5v8.3h6.3c-.1.9-.1 1.8-.1 2.8 0 1.2.1 2.4.1 3.6h-6.3v8.3h7.7c4.3 16 17.6 23.5 33.1 23.5 17.4 0 28.2-9.4 30.1-24.3h-15.1c-1.5 7.1-7.5 11.3-15.5 11.3-6.9 0-13.1-3.1-16.1-10.5h17.7l2.2-8.3h-21.7c-.1-1.1-.2-2.4-.2-3.7 0-.9 0-1.8.1-2.7h23.4l2.2-8.3h-24c2.8-8 9.1-11.4 16.3-11.4zM283.3 176.9h-28.2v78.2h-85v28.4h113.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.5 0H56.6v233.8h177.1V75.1L144.5 0zm4.3 40.9l27.3 23h-27.3v-23zM85.1 205.3V28.5h35.4v63.7h84.8v113.1H85.1z"
})))));